var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSpinner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_603_6335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0892 18.6716C23.2227 18.6716 21.3293 14.4378 21.3293 11.5445C21.3293 6.36019 25.3706 3.90462 28.2998 3.90462C31.229 3.90462 32.2973 5.2051 32.2973 5.2051C31.9487 5.08792 31.5826 5.02959 31.2144 5.03255C27.6887 5.03255 26.7906 7.9738 26.7906 9.44203C26.7906 11.3592 28.2009 13.647 31.2144 13.647C34.7612 13.647 35.5912 10.653 35.5912 9.23593C35.5912 5.08208 31.3457 0 20.809 0C9.75511 0 0.00781636 9.50913 0.00781636 20.0551C-0.000288831 35.4164 12.767 39.9984 20.2076 39.9984H35.9997V13.9569C34.9104 16.772 32.4448 18.6716 29.0892 18.6716Z",
    fill: "#2F2F2F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_603_6335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpinner);
export default __webpack_public_path__ + "static/media/icon-spinner.73039a4f3fafc1993d52af4de47e5d5b.svg";
export { ForwardRef as ReactComponent };